import React from "react";

const services = [
  {
    num: "01",
    image:
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    name: "Thai Sports Massage",
    price: "From ₹3,000",
    duration: "60 Min · 90 Min",
    description: "Traditional Thai techniques with assisted stretching",
  },
  {
    num: "02",
    image:
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    name: "Swedish Massage",
    price: "From ₹2,000",
    duration: "60 Min · 90 Min",
    description: "Gentle, relaxing full-body massage",
  },
  {
    num: "03",
    image:
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    name: "Hot Stone Massage",
    price: "From ₹3,500",
    duration: "60 Min · 90 Min",
    description: "Heated stones for deep muscle relaxation",
  },
  {
    num: "04",
    image:
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    name: "Royal H2O Signature",
    price: "From ₹4,000",
    duration: "120 Min · 180 Min",
    description: "Luxury hydrotherapy experience",
  },
  {
    num: "05",
    image:
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    name: "Aroma Therapy",
    price: "From ₹2,000",
    duration: "60 Min · 90 Min",
    description: "Essential oils for mind and body balance",
  },
  {
    num: "06",
    image:
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    name: "Deep Tissue Massage",
    price: "From ₹3,000",
    duration: "60 Min · 90 Min",
    description: "Targeted deep muscle therapy",
  },
  {
    num: "07",
    image:
      "https://images.unsplash.com/photo-1506126613408-eca07ce68773?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    name: "Balinese Massage",
    price: "From ₹2,500",
    duration: "60 Min · 90 Min",
    description: "Traditional Indonesian techniques",
  },
  {
    num: "08",
    image:
      "https://images.unsplash.com/photo-1596462502278-27bfdc403348?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    name: "Warm Candle Massage",
    price: "From ₹3,500",
    duration: "60 Min",
    description: "Aromatic warm oil therapy",
  },
];

function Services() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="services-section" id="services">
      <div className="services-header">
        <div>
          <div className="section-label" style={{ color: "var(--gold)" }}>
            What We Do
          </div>
          <h2 className="section-title" style={{ color: "#f7f3ee" }}>
            Professional Spa &<br />
            <em>Beauty Services</em>
          </h2>
        </div>
        <button
          className="btn-outline"
          onClick={() => scrollToSection("pricing")}
        >
          View All Services
        </button>
      </div>
      <div className="services-grid reveal">
        {services.map((s, i) => (
          <div
            className="service-card"
            key={s.num}
            style={{ transitionDelay: `${i * 0.05}s` }}
          >
            <div className="service-card-inner">
              {/* <span className="service-num">{s.num}</span> */}
              <div className="service-image-wrapper">
                <img src={s.image} alt={s.name} className="service-image" />
                <div className="service-image-overlay"></div>
              </div>
              <div className="service-content">
                <div className="service-name">{s.name}</div>
                <div className="service-description">{s.description}</div>
                <div className="service-price">{s.price}</div>
                <div className="service-duration">{s.duration}</div>
              </div>
            </div>
            <div className="service-arrow">→</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Services;
